<template>
    <div>
        <div class="row">
            <div v-if="projects.length > 0" class="bg-white shadow-md rounded mb-6 mt-4 w-full">
                <table class="text-left w-full border-collapse">
                    <thead>
                        <tr>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                #
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                <button @click="parseFilter('name')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'name' ? 'text-teal' : 'text-grey-darkest'">
                                    Project Name
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'name' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'name' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-boldco uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                <button @click="parseFilter('sequential_team_id')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'sequential_team_id' ? 'text-teal' : 'text-grey-darkest'">
                                    ID
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'sequential_team_id' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'sequential_team_id' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                <button @click="parseFilter('sales_status')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'sales_status' ? 'text-teal' : 'text-grey-darkest'">
                                    {{ getFieldLabel(fieldLabels , 'sales-status') }}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'sales_status' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'sales_status' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                <button @click="parseFilter('base_bid')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'base_bid' ? 'text-teal' : 'text-grey-darkest'">
                                    {{ getFieldLabel(recordDetailFieldLabels , 'base-bid') }}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'base_bid' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'base_bid' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                <button @click="parseFilter('gross_margin_pct')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'gross_margin_pct' ? 'text-teal' : 'text-grey-darkest'">
                                    {{ getFieldLabel(recordDetailFieldLabels , 'gross-margin') }} (%)
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'gross_margin_pct' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'gross_margin_pct' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                <button @click="parseFilter('gross_margin')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'gross_margin' ? 'text-teal' : 'text-grey-darkest'">
                                    {{ getFieldLabel(recordDetailFieldLabels , 'gross-margin') }}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'gross_margin' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'gross_margin' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                                <button @click="parseFilter('account_manager')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'account_manager' ? 'text-teal' : 'text-grey-darkest'">
                                    {{ getFieldLabel(fieldLabels , 'account-mgr') }}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'account_manager' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'account_manager' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                <button @click="parseFilter('bid_date')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'bid_date' ? 'text-teal' : 'text-grey-darkest'">
                                    {{ getFieldLabel(fieldLabels , 'bid-date') }}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'bid_date' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'bid_date' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden xl:table-cell">
                                <button @click="parseFilter('last_comment')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'last_comment' ? 'text-teal' : 'text-grey-darkest'">
                                    Last Comment
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'last_comment' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'last_comment' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr @click.prevent="editProject(project)" class="hover:bg-grey-lighter cursor-pointer"
                            v-for="(project, index) in filtered" :key="project.id">
                            <td class="pl-4 py-3 border-b border-grey-light text-xs">
                                <div class="text-sm">{{ index + 1 }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs">
                                <div class="text-sm">{{ project.name }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden md:table-cell">
                                <div>{{ project.custom_project_id ? project.custom_project_id : project.sequential_team_id }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs">
                                <div>{{ project.sales_status }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden md:table-cell">
                                <div>{{ project.base_bid }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden md:table-cell">
                                <div>{{ project.gross_margin_pct }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs">
                                <div>{{ project.gross_margin }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden lg:table-cell">
                                <div>{{ project.account_manager }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden md:table-cell">
                                <div>{{ project.bid_date }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden xl:table-cell">
                                <div>{{ project.last_comment ? commentText(project.last_comment.comment) : ''}}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: ['projects', 'fieldLabels', 'recordDetailFieldLabels'],

    data() {
        return {
            list: [],
            filtered: [],
            currentFilter: {
                property: null,
                direction: null
            }
        }
    },

    created() {
        this.list = [ ...this.projects ];
        this.filtered = [ ...this.projects ];
    },

    methods: {
        editProject(project) {
            window.location = route('project.edit', {project: project.id});
        },

        commentText(comment){
            comment = comment.replace(/<[^>]*>?/gm, '');
            if (comment.length >= 24) {
                return comment.substring(0,25) + "...";
            }
            return comment;
        },

        parseFilter(property) {
            if (property === this.currentFilter.property) {
                this.currentFilter.direction = this.currentFilter.direction === 'desc' ? 'asc' : 'desc';
            } else if (property !== this.currentFilter.property || !this.currentFilter.direction) {
                this.currentFilter.direction = 'asc';
            }

            this.currentFilter.property = property;

            this.sortList();
        },

        sortList() {
            this.filtered = _.orderBy(this.list, item => {
                if (this.currentFilter.property === 'base_bid') {
                    return Number(item[this.currentFilter.property].replace(/[^0-9.]/g, ''));
                } else if (this.currentFilter.property === 'last_comment') {
                    return item.last_comment ? this.commentText(item.last_comment.comment).toUpperCase() : null;
                }

                return isNaN(item[this.currentFilter.property]) || !item[this.currentFilter.property] || !moment(item[this.currentFilter.property]).isValid() ?
                    item[this.currentFilter.property].toUpperCase() :
                    item[this.currentFilter.property];
            }, this.currentFilter.direction);
        }
    },
}
</script>
